import React, { useState, useContext,useEffect } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import { ShopContext } from '../context/ShopContext';

const ResetPassword = () => {
    useEffect(() => {
          const backendUrl = import.meta.env.VITE_BACKEND_URL; // ✅ dynamic URL
          axios.post(`${backendUrl}/api/analytics/visit`, { page: "Reset Paasowrd" })
            .then(res => console.log(" visit recorded:", res.data))
            .catch(err => console.error("Analytics error:", err));
        }, []);
  const { navigate, backendUrl } = useContext(ShopContext);
  const [resetEmail, setResetEmail] = useState('');
  const [otp, setOtp] = useState('');
  const [password, setPassword] = useState('');
  const [otpSent, setOtpSent] = useState(false);
  const [otpVerified, setOtpVerified] = useState(false);
  const [isOtpResendAvailable, setIsOtpResendAvailable] = useState(false);

  const handleSendOtp = async () => {
    try {
      const response = await axios.post(`${backendUrl}/api/user/reset-password/send-otp`, { email: resetEmail });
      if (response.data.success) {
        toast.success('OTP sent to your email.');
        setOtpSent(true);
        setTimeout(() => setIsOtpResendAvailable(true), 30000);
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      toast.error('Failed to send OTP.');
    }
  };

  const handleVerifyOtp = async () => {
    try {
      const response = await axios.post(`${backendUrl}/api/user/reset-password/verify-otp`, { email: resetEmail, otp });
      if (response.data.success) {
        toast.success('OTP verified. Please reset your password.');
        setOtpVerified(true);
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      toast.error('Failed to verify OTP.');
    }
  };

  const handleResetPassword = async () => {
    try {
      const response = await axios.post(`${backendUrl}/api/user/reset-password`, { email: resetEmail, password });
      if (response.data.success) {
        toast.success('Password reset successfully.');
        navigate('/login');
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      toast.error('Failed to reset password.');
    }
  };

  const handleResendOtp = async () => {
    setIsOtpResendAvailable(false);
    handleSendOtp();
  };

  return (
    <div className="max-w-md w-full mx-auto p-6 rounded-xl shadow-lg border border-[#FF4902] mt-10 mb-10">
      <h2 className="text-2xl font-bold text-[#FF4902] text-center mb-4">Reset Password</h2>

      {!otpSent ? (
        <input
          onChange={(e) => setResetEmail(e.target.value)}
          value={resetEmail}
          type="email"
          className="w-full p-3 border border-[#FF4902] rounded-lg focus:outline-none focus:ring-2 focus:ring-[#FF4902] mb-4"
          placeholder="Enter your email"
          required
        />
      ) : otpVerified ? (
        <input
          onChange={(e) => setPassword(e.target.value)}
          value={password}
          type="password"
          className="w-full p-3 border border-[#FF4902] rounded-lg focus:outline-none focus:ring-2 focus:ring-[#FF4902] mb-4"
          placeholder="New Password"
          required
        />
      ) : (
        <input
          onChange={(e) => setOtp(e.target.value)}
          value={otp}
          type="text"
          className="w-full p-3 border border-[#FF4902] rounded-lg focus:outline-none focus:ring-2 focus:ring-[#FF4902] mb-4"
          placeholder="Enter OTP"
          required
        />
      )}

      {!otpSent ? (
        <button
          type="button"
          onClick={handleSendOtp}
          className="w-full bg-[#FF4902] hover:bg-[#FF4902] text-white font-semibold py-3 rounded-lg transition duration-300"
        >
          Send OTP
        </button>
      ) : otpVerified ? (
        <button
          type="button"
          onClick={handleResetPassword}
          className="w-full bg-[#FF4902] hover:bg-[#FF4902] text-white font-semibold py-3 rounded-lg transition duration-300"
        >
          Reset Password
        </button>
      ) : (
        <div className="space-y-4">
          <button
            type="button"
            onClick={handleVerifyOtp}
            className="w-full bg-[#FF4902] hover:bg-[#FF4902] text-white font-semibold py-3 rounded-lg transition duration-300"
          >
            Verify OTP
          </button>
          {isOtpResendAvailable && (
            <button
              type="button"
              onClick={handleResendOtp}
              className="w-full text-[#FF4902] hover:text-[#FF4902] font-semibold"
            >
              Resend OTP
            </button>
          )}
        </div>
      )}

      <p
        className="text-center text-sm text-gray-600 mt-4 cursor-pointer hover:text-[#FF4902]"
        onClick={() => navigate('/login')}
      >
        Login Here
      </p>
    </div>
  );
};

export default ResetPassword;
